// 1. React and fabric. 
// 2. Store and Types. 
// 3. Scripts. 

const ControlChars = { CrLf: '\r\n', Cr: '\r', Lf: '\n', Tab: '\t' };

export default class StringBuilder
{
	private value : string;
	public  length: number;

	constructor()
	{
		this.value  = '';
		this.length = this.value.length;
	}

	public Append(s: string)
	{
		this.value  = this.value + s;
		this.length = this.value.length;
	}

	public AppendLine(s?: string)
	{
		if ( s === undefined )
		{
			this.value  = this.value + ControlChars;
			this.length = this.value.length;
		}
		else
		{
			this.value  = this.value + s;
			this.length = this.value.length;
		}
	}

	public toString()
	{
		return this.value;
	}
}

